import styled from 'styled-components';

export const StyledFooter = styled.footer`
    text-align: center;
    font-family: Roboto Condensed, serif;
    font-weight: 300;
    font-size: 0.75rem;
    background-color: #2d3436;
    background-image: linear-gradient(to right, #2d3436, #000000, #2d3436);
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;  
    z-index: 999;  
`;

export const FooterText = styled.p`
    color: grey;
    margin: 0;    
`;
